import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GalleryDto } from '@picflow/types';
import { firstValueFrom } from 'rxjs';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { ChecklistService } from '../../../services/checklist.service';
import { DataLoaderService } from '../../../services/data-loader.service';
import { OnGetData } from '../../../services/dialog.service';
import { StateService } from '../../../services/state.service';
import { TenantService } from '../../../services/tenant.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { CreateTenantFormComponent } from '../../components/create-tenant-form/create-tenant-form.component';

@Component({
  selector: 'app-workspace-dialog',
  templateUrl: './workspace-dialog.component.html',
  styleUrls: ['./workspace-dialog.component.scss'],
  standalone: true,
  imports: [CreateTenantFormComponent, RouterLink, ButtonDirective, LoadingIndicatorComponent],
})
export class WorkspaceDialogComponent implements OnGetData {
  dialogName = 'workspace';
  close: (...args) => void;
  onDone: () => void;
  loading = false;
  initialValue: { name: string; path: string };
  gallery: GalleryDto;

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 40 };
  }

  constructor(
    public state: StateService,
    private tenantService: TenantService,
    private checklistService: ChecklistService,
    private loader: DataLoaderService
  ) {}

  onGetData(data: { gallery: GalleryDto; onDone: () => unknown }, close: (...args) => void) {
    this.close = close;
    this.gallery = data.gallery;
    this.onDone = data.onDone;
    this.initialValue = { name: `${this.state.user.first_name}'s Workspace`, path: this.state.activeTenant.path };
  }

  async confirmWorkSpace(event: { name: string; path: string }) {
    this.loading = true;
    await this.tenantService.updateOrganization({
      name: event.name,
      slug: event.path,
    });
    await firstValueFrom(this.checklistService.markItemAsDone('setWorkspaceName'));
    this.loader.removeFuzzy('galleries');
    if (this.gallery?.['tenant']?.['id']) {
      this.gallery['tenant']['path'] = event.path;
    }
    this.onDone?.();
  }
}
